import { render, staticRenderFns } from "./HistoryDetails.vue?vue&type=template&id=a224b9b4&scoped=true"
import script from "./HistoryDetails.vue?vue&type=script&lang=ts"
export * from "./HistoryDetails.vue?vue&type=script&lang=ts"
import style0 from "./HistoryDetails.vue?vue&type=style&index=0&id=a224b9b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a224b9b4",
  null
  
)

export default component.exports